// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__Qau5D","rootSmall":"AddTileButton_rootSmall__28YEo"};